import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";

import {
    PredictionBarChart,
    RatePrediction,
    PredictionLineChart,
    PredictionLoadRatesMap,
    PredictionLoadRatesBestOutbounds,
} from "@/components/dataPages";
import { useQuery } from "@/utils/query";
import { clearLoadRatesState, getMarketToMarketRoute } from "@/state/loadRatesSlice";
import { ErrorPage } from "@/components/common/errors";
import { setSearchType } from "@/state/searchInputSlice";

export const PredictionLoadRates = () => {
    const [filteredMarkets, setFilteredMarkets] = useState(null);
    const { error } = useSelector((state) => state.loadRates.ratePrediction);
    const isDesktop = useMediaQuery({
        query: "(min-width: 1024px)",
    });
    const { pickupZip, deliveryZip } = useQuery();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMarketToMarketRoute({ pickupZip, deliveryZip }));
    }, [pickupZip, deliveryZip]);

    useEffect(() => {
        dispatch(setSearchType("load_rates"));
        return () => {
            dispatch(clearLoadRatesState());
        };
    }, []);

    return !error ? (
        <div className="flex flex-col w-full w-max-[1436px] pt-1">
            <div className="flex flex-col lg:flex-row bg-cm-p-surface rounded-lg w-full pt-4 px-6 pb-6 drop-shadow-[0_4px_4px_rgba(0,0,0,0.05)]">
                <div className="flex flex-col sm:flex-row justify-between gap-5 sm:gap-2">
                    <div className="w-[230px]">
                        <RatePrediction />
                    </div>
                    {!isDesktop && (
                        <div className="w-full border-t border-cm-p-outline-variation py-4 sm:w-[282px] sm:border-0 sm:py-0">
                            <PredictionBarChart
                                withDelivery
                                title="Load volume"
                                tooltipText="Load volume by day gives insights of frequency of loads available shown by day of the pickup, in percentages."
                            />
                        </div>
                    )}
                </div>

                <div className="lg:mx-4 xl:ml-16 xl:mr-14 w-full lg:w-[calc(100% - 230px - 282px - 120px)] overflow-hidden">
                    <PredictionLineChart withFlat />
                </div>
                {isDesktop && (
                    <div className="w-[282px] min-w-[282px]">
                        <PredictionBarChart
                            withDelivery
                            title="Load volume"
                            tooltipText="Load volume by day gives insights of frequency of loads available shown by day of the pickup, in percentages."
                        />
                    </div>
                )}
            </div>
            <div className="overflow-hidden relative h-[1048px] md:h-[762px] lg:h-[397px] w-full flex mt-8 rounded-lg flex-col">
                <PredictionLoadRatesMap filteredMarkets={filteredMarkets} />
                <PredictionLoadRatesBestOutbounds setMarketsToPin={setFilteredMarkets} />
            </div>
        </div>
    ) : (
        <ErrorPage
            title="Oops! Something went wrong."
            description="Something went wrong while loading this page. If the problem persists, report it to our team using the feedback button on home page."
        />
    );
};
